import { Box, Typography } from '@mui/material'

const containerSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  cursor: 'text',
  width: '100%',
}

const labelSx = { py: 0 }

const DraftHeaderRow = ({
  label,
  children,
  onClick,
  disabled,
}: {
  label: string
  children: React.ReactNode
  onClick?: () => void
  disabled?: boolean
}) => {
  return (
    <Box
      sx={containerSx}
      onClick={onClick}
    >
      {label && (
        <Typography
          sx={labelSx}
          variant="body2"
          color={disabled ? 'text.disabled' : 'text.secondary'}
        >
          {label}
        </Typography>
      )}
      {children}
    </Box>
  )
}

export default DraftHeaderRow
